// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"ee8b079e","278":"ee8b079e","370":"ee8b079e","839":"ee8b079e"}[chunkId] + ".chunk.css";
};